import React, { useEffect, useState } from 'react';
import { useCart } from '../context/CartContext';
import { ShoppingCartIcon, MenuIcon, XIcon, ChevronLeftIcon } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
interface NavbarProps {
  isLandingPage?: boolean;
}
export const Navbar: React.FC<NavbarProps> = ({
  isLandingPage = false
}) => {
  const {
    itemCount
  } = useCart();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSafari, setIsSafari] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // Check if current page is cart or checkout
  const isCartOrCheckout = location.pathname === '/cart' || location.pathname === '/cart2' || location.pathname === '/checkout';
  // Check if current page is the superfoods info page
  const isSuperfoodsInfoPage = location.pathname === '/superpotraviny-info';
  // Check if current page is the superfoods page
  const isSuperfoodsPage = location.pathname === '/superpotraviny';
  // Check if we came from /treninky landing page
  const cameFromTrainingLanding = sessionStorage.getItem('cameFromTrainingLanding') === 'true';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    // Detect Safari browser on desktop only
    const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isDesktop = window.innerWidth >= 768;
    setIsSafari(isSafariBrowser && isDesktop);
  }, []);
  // Track when user is on /treninky page
  useEffect(() => {
    if (location.pathname === '/treninky') {
      sessionStorage.setItem('cameFromTrainingLanding', 'true');
    }
  }, [location.pathname]);
  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // If on cart2 page (BHS cart), go back to /bhs
    if (location.pathname === '/cart2') {
      navigate('/bhs');
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
    // If on cart page and came from /treninky, go back to /treninky
    else if (location.pathname === '/cart' && cameFromTrainingLanding) {
      sessionStorage.removeItem('cameFromTrainingLanding');
      navigate('/treninky');
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
    // If on /treninky page, go to main page
    else if (location.pathname === '/treninky') {
      sessionStorage.removeItem('cameFromTrainingLanding');
      navigate('/');
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
    // Otherwise, go to home or scroll to top
    else {
      navigate('/');
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };
  const scrollToSection = (id: string) => {
    if (id === 'home') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    // Special handling for training section to match HeroSection scroll behavior
    if (id === 'training') {
      const element = document.getElementById('plan-cards');
      if (element) {
        const navbarHeight = 80; // Height of fixed navbar
        const additionalOffset = 20; // Extra spacing for better visibility
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight - additionalOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        return;
      }
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black shadow-lg py-2' : 'bg-gradient-to-b from-black/90 to-transparent py-3 md:py-4'}`} data-id="element-710">
      <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-711">
        <a href="#" onClick={handleLogoClick} className="flex items-center group" data-id="element-712">
          <motion.div whileHover={{
          scale: 1.05
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 10
        }} className="relative" data-id="element-713">
            <div className="absolute -inset-1 bg-green-500/20 rounded-full blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-714"></div>
            <div className="relative" data-id="element-715">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/52223ed0-706c-4e32-b473-ccdee39b9f66.png" alt="Body-Hack Logo" className="h-14 md:h-16 w-auto object-contain" data-id="element-716" />
            </div>
          </motion.div>
        </a>
        {!isCartOrCheckout && !isSuperfoodsInfoPage && !isSuperfoodsPage && <>
            <div className="hidden md:flex items-center md:ml-8 space-x-12" data-id="element-717">
              <a href="#" onClick={e => {
            e.preventDefault();
            scrollToSection('home');
          }} className="text-white hover:text-green-500 transition-colors font-bold uppercase text-lg hover:-translate-y-1 transform transition-transform" data-id="element-718">
                Domů
              </a>
              <a href="#training" onClick={e => {
            e.preventDefault();
            scrollToSection('training');
          }} className="text-white hover:text-green-500 transition-colors font-bold uppercase text-lg hover:-translate-y-1 transform transition-transform" data-id="element-719">
                Tréninkové plány
              </a>
              {!isLandingPage && <>
                  
                  <a href="#my-story" onClick={e => {
              e.preventDefault();
              scrollToSection('my-story');
            }} className="text-white hover:text-green-500 transition-colors font-bold uppercase text-lg hover:-translate-y-1 transform transition-transform" data-id="element-720">
                    Můj příběh
                  </a>
                  <a href="#faq" onClick={e => {
              e.preventDefault();
              scrollToSection('faq');
            }} className="text-white hover:text-green-500 transition-colors font-bold uppercase text-lg hover:-translate-y-1 transform transition-transform" data-id="element-721">
                    FAQ
                  </a>
                  <a href="#contact" onClick={e => {
              e.preventDefault();
              scrollToSection('contact');
            }} className="text-white hover:text-green-500 transition-colors font-bold uppercase text-lg hover:-translate-y-1 transform transition-transform" data-id="element-722">
                    Kontakt
                  </a>
                </>}
            </div>
            <div className="md:hidden flex items-center" data-id="element-723">
              <Link to="/cart" className="relative mr-4" data-id="element-724">
                <ShoppingCartIcon className="h-7 w-7 text-white cursor-pointer" data-id="element-725" />
                {itemCount > 0 && <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold" data-id="element-726">
                    {itemCount}
                  </span>}
              </Link>
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="focus:outline-none" data-id="element-727">
                {isMenuOpen ? <XIcon className="h-7 w-7 text-white" data-id="element-728" /> : <MenuIcon className="h-7 w-7 text-white" data-id="element-729" />}
              </button>
            </div>
          </>}
        {!isCartOrCheckout && !isSuperfoodsInfoPage && !isSuperfoodsPage && <div className="hidden md:block" data-id="element-730">
            <Link to="/cart" className="relative" data-id="element-731">
              <ShoppingCartIcon className="h-8 w-8 text-white cursor-pointer hover:text-green-500 transition-colors hover:-translate-y-1 transform transition-transform" data-id="element-732" />
              {itemCount > 0 && <span className={`absolute bg-green-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold ${isSafari ? '-top-1 -right-1' : '-top-2 -right-2'}`} style={isSafari ? {
            top: '-4px',
            right: '-4px'
          } : undefined} data-id="element-733">
                  {itemCount}
                </span>}
            </Link>
          </div>}
      </div>
      {/* Mobile menu - only show on main page */}
      {isMenuOpen && !isCartOrCheckout && !isSuperfoodsInfoPage && !isSuperfoodsPage && <div className="md:hidden bg-black bg-opacity-95 px-4 py-4 absolute w-full" data-id="element-734">
            <div className="flex flex-col space-y-4" data-id="element-735">
              <a href="#" className="text-white hover:text-green-500 transition-colors font-semibold text-lg uppercase hover:-translate-y-1 transform transition-transform" onClick={e => {
          e.preventDefault();
          scrollToSection('home');
        }} data-id="element-736">
                Domů
              </a>
              <a href="#training" className="text-white hover:text-green-500 transition-colors font-semibold text-lg uppercase hover:-translate-y-1 transform transition-transform" onClick={e => {
          e.preventDefault();
          scrollToSection('training');
        }} data-id="element-737">
                Tréninkové plány
              </a>
              {!isLandingPage && <>
                  
                  <a href="#my-story" className="text-white hover:text-green-500 transition-colors font-semibold text-lg uppercase hover:-translate-y-1 transform transition-transform" onClick={e => {
            e.preventDefault();
            scrollToSection('my-story');
          }} data-id="element-738">
                    Můj příběh
                  </a>
                  <a href="#faq" className="text-white hover:text-green-500 transition-colors font-semibold text-lg uppercase hover:-translate-y-1 transform transition-transform" onClick={e => {
            e.preventDefault();
            scrollToSection('faq');
          }} data-id="element-739">
                    FAQ
                  </a>
                  <a href="#contact" className="text-white hover:text-green-500 transition-colors font-semibold text-lg uppercase hover:-translate-y-1 transform transition-transform" onClick={e => {
            e.preventDefault();
            scrollToSection('contact');
          }} data-id="element-740">
                    Kontakt
                  </a>
                </>}
            </div>
          </div>}
    </nav>;
};